module.exports = __webpack_public_path__ + "static/media/bg-2.9331cb89.jpg";